import { ArticleStatus, IArticle, IOrder, IStock } from '@alberta/konexi-shared';
import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { cloneDeep } from 'lodash';
import { checkIfArticleLineisOrderable } from 'src/app/business/order/order-functions';
import { ArticleDto } from 'src/app/shared/models/article/article-dto.model';

import { OrderArticleEditComponent } from '../../../../../../../../shared/components/order-article-edit-modal/order-article-edit-modal.component';
import { SingleOrderedArticleLineViewModel } from './../../../../../../../../business/single-order/single-ordered-articleline-view-model';

@Component({
  selector: 'itl-single-ordered-article-list-item',
  templateUrl: './single-ordered-article-list-item.component.html',
  styleUrls: ['./single-ordered-article-list-item.component.scss'],
  providers: [DatePipe],
})
export class SingleOrderedArticleListItemComponent implements OnChanges {
  @Input()
  public articleLine: SingleOrderedArticleLineViewModel = new SingleOrderedArticleLineViewModel();
  @Input()
  public order: IOrder;
  @Input()
  public isLast = false;
  @Input()
  public showDetails = false;
  @Input()
  public stock: { [key: string]: IStock };
  @Input()
  public isArticleEditDisabled = false;
  @Output()
  public articleLineChange: EventEmitter<SingleOrderedArticleLineViewModel> =
    new EventEmitter<SingleOrderedArticleLineViewModel>();
  public article: IArticle = new ArticleDto();
  public canBeOrdered = true;
  public articleIsDelayed: boolean;
  public delayedTo: string;

  constructor(private _modalController: ModalController, private _datePipe: DatePipe) {}

  ngOnChanges(): void {
    this.article = this.articleLine.article;
    this.canBeOrdered = checkIfArticleLineisOrderable(this.article, this.order.deliveryDate);

    if (this.article.status === ArticleStatus.Delayed) {
      this.articleIsDelayed = true;
      this.delayedTo = this.article.delayedTo
        ? `${this._datePipe.transform(this.article.delayedTo, 'dd.MM.yyyy')}`
        : 'k.A.';
    }
  }

  public setRecommendedQuantity() {
    if (this.isArticleEditDisabled) {
      return;
    }
    this.articleLine.quantity = this.articleLine.recommendedQuantity;
    this.articleLineChange.emit(this.articleLine);
  }

  public async editArticle(articleLine: SingleOrderedArticleLineViewModel) {
    if (this.isArticleEditDisabled) {
      return;
    }
    const modal = await this._modalController.create({
      component: OrderArticleEditComponent,
      backdropDismiss: false,
      componentProps: {
        articleLine: cloneDeep(articleLine),
      },
      cssClass: 'fullPageModal',
    });
    await modal.present();
    const response = await modal.onDidDismiss();
    if (response && response.data) {
      this.articleLineChange.emit(response.data);
    }
  }

  public activeToggled() {
    this.articleLine.active = !this.articleLine.active;
    if (this.articleLine.maxAmount) {
      if (!this.articleLine.active) {
        this.articleLine.maxAmount.currentQuantity +=
          this.articleLine.quantity * +this.articleLine.packagingUnit.quantity;
      } else {
        if (this.articleLine.isPrivateSale) {
          this.articleLine.isPrivateSale = false;
        }
        this.articleLine.maxAmount.currentQuantity -=
          this.articleLine.quantity * +this.articleLine.packagingUnit.quantity;
      }
    }
    this.articleLineChange.emit(this.articleLine);
  }
}
